<template>
  <el-card>
    <header slot="header">
      <h2>Manage Dropdown Lists</h2>
    </header>

    <section>
      <el-row>
        <el-col :span="12" :offset="6">
          <div style="display: flex; justify-content: space-between; margin-bottom: 2rem;">
            <h4>Credit Dashboard Agency list</h4>
            <button class="btn btn-primary" @click="addAgency()" size="mini">Add Agency</button>
          </div>
        </el-col>
        <el-col :span="12" :offset="6">
          <div class="custom-tree-container">
            <div class="block" style="max-height: 35vh; overflow-y: scroll; padding-bottom: 10vh;">
              <el-tree
                  v-loading="loading"
                  :data="agencyData"
                  node-key="id"
                  default-expand-all
                  :expand-on-click-node="false">
					  <span :class="{'tree-node': true, 'tree-node-key': node.level === 1, 'tree-node-item': node.level === 2,}"
                  slot-scope="{ node, data }">
							<el-input v-model="data.key" size="mini" @blur="saveAgencyChanges()" v-if="node.level === 2"
                        style="width: 10vw;"></el-input>
						  	<el-input v-model="data.label" size="mini" @blur="saveAgencyChanges()"></el-input>
						<span>
						  <el-button
                  v-if="node.level === 1"
                  type="text"
                  size="mini"
                  @click="() => append(data, 'agency')">
							Append
						  </el-button>
						  <el-button
                  type="text"
                  size="mini"
                  @click="() => delConfirm(node, data, 'agency')">
							Delete
						  </el-button>
						</span>
					  </span>
              </el-tree>
            </div>
          </div>
        </el-col>

        <el-col :span="12" :offset="6">
          <div style="display: flex; justify-content: space-between; margin: 2rem 0;">
            <h4>Credit Dashboard Channel list</h4>
            <button class="btn btn-primary" @click="addChannelGroup()" size="mini">Add Group</button>
          </div>
        </el-col>
        <el-col :span="12" :offset="6">
          <div class="custom-tree-container">
            <div class="block" style="max-height: 35vh; overflow-y: scroll; padding-bottom: 10vh;">
              <el-tree
                  v-loading="loading"
                  :data="channelData"
                  node-key="id"
                  default-expand-all
                  :expand-on-click-node="false">
					  <span :class="{'tree-node': true, 'tree-node-key': node.level === 1, 'tree-node-item': node.level === 2,}"
                  slot-scope="{ node, data }">
						  	<el-input v-model="data.label" size="mini" @blur="saveChannelChanges()"></el-input>
							<el-input v-model="data.key" size="mini" @blur="saveChannelChanges()" v-if="node.level === 2"
                        style="width: 10vw; margin-left: 1rem;"></el-input>
						<span>
						  <el-button
                  v-if="node.level === 1"
                  type="text"
                  size="mini"
                  @click="() => append(data, 'channel')">
							Append
						  </el-button>
						  <el-button
                  type="text"
                  size="mini"
                  @click="() => delConfirm(node, data, 'channel')">
							Delete
						  </el-button>
						</span>
					  </span>
              </el-tree>
            </div>
          </div>
        </el-col>
      </el-row>
    </section>
  </el-card>
</template>

<script>

import axios, {RepositoryError} from '../../repositories';

let id = 1000;

export default {
  name: 'FinanceDropdownList',
  data() {
    return {
      agencyData: [],
      channelData: [],
      loading: false,
    }
  },

  async mounted() {
    this.loading = true;
    await Promise.all([
      this.fetchAgencyList(),
      this.fetchChannelList(),
    ]);
    this.loading = false;
  },

  methods: {
    async saveAgencyChanges() {
      try {
        this.loading = true;
        await axios.put(`/manage-dropdown/agency-list`, {
          data: this.agencyData,
        })
      } catch (err) {
        if (err instanceof RepositoryError) {
          throw new Error(`Failed to update agency list: ${err}`);
        }
        throw err;
      } finally {
        this.loading = false;
      }
    },
    async saveChannelChanges() {
      try {
        this.loading = true;
        await axios.put(`/manage-dropdown/channel-list`, {
          data: this.channelData,
        })
      } catch (err) {
        if (err instanceof RepositoryError) {
          throw new Error(`Failed to update channel list: ${err}`);
        }
        throw err;
      } finally {
        this.loading = false;
      }
    },
    addAgency() {
      this.agencyData.push({id: id++, label: 'COUNTRY CODE', level: 1, children: []});
    },
    addChannelGroup() {
      this.channelData.push({id: id++, label: 'NEW', level: 1, children: []});
    },
    append(data, type) {
      const newChild = {id: id++, label: 'DETAIL NAME', key: 'KEY', children: []};
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(newChild);
      if (type === 'agency') {
        this.saveAgencyChanges();
      } else {
        this.saveChannelChanges();
      }
    },
    remove(node, data, type) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      children.splice(index, 1);
      if (type === 'agency') {
        this.saveAgencyChanges();
      } else {
        this.saveChannelChanges();
      }
    },
    delConfirm(node, data, type) {
      this.$confirm('This will permanently delete this item. Continue?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.remove(node, data, type);
      })
    },
    async fetchAgencyList() {
      try {
        const response = await axios.get(`/manage-dropdown/agency-list`);
        this.agencyData = Array.isArray(response.data) ? response.data : [];
      } catch (err) {
        if (err instanceof RepositoryError) {
          throw new Error(`Failed to fetch agency list: ${err}`);
        }
        throw err;
      }
    },
    async fetchChannelList() {
      try {
        const response = await axios.get(`/manage-dropdown/channel-list`);
        this.channelData = Array.isArray(response.data) ? response.data : [];
      } catch (err) {
        if (err instanceof RepositoryError) {
          throw new Error(`Failed to fetch channel list: ${err}`);
        }
        throw err;
      }
    },
  },
}
</script>

<style scoped>
.tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 8px;
}

.tree-node-key {
  font-size: 16px;
  font-weight: bold;
}

.tree-node-item {
  font-size: 14px;
}

.el-input--mini .el-input__inner {
  border: none;
}

.el-tree-node__content:hover {
  background: none;
}
</style>
